import {JsonLd} from 'react-schemaorg';
import {Product} from 'schema-dts';
import {BASENAME} from '../utils/constants';
import {Scraper} from '../types';

export const ScraperStructuredData = ({scraper}: {scraper: Scraper}) => (
  <JsonLd<Product>
    item={{
      '@context': 'https://schema.org',
      '@type': 'Product',
      name: scraper.name,
      image: `${BASENAME}static/${scraper.logo}`,
      description: scraper.description,
      brand: {
        '@type': 'Brand',
        name: 'ScrapingBot',
      },
      category: scraper.category,
      keywords: scraper.tags.join(', '),
      logo: `${BASENAME}static/${scraper.logo}`,
      offers: {
        '@type': 'Offer',
        price: '0',
        priceCurrency: 'USD',
        availability: 'https://schema.org/InStock',
      },
    }}
  />
);
